import { SUPPORT_TICKET_SHOPPABLE_REQUEST_URL } from "@/constants";
import ListView, { ListViewItem } from "@ingka/list-view";
import { CreateUploadDtoTypeEnum } from "generated";
import { useNavigate } from "react-router";

type Props = {
  uploadId: number;
  isApproved: boolean;
  uploadType: CreateUploadDtoTypeEnum;
  onOpenCommentModal: () => void;
};

export const CommentLinkPane = ({
  uploadId,
  isApproved,
  uploadType,
  onOpenCommentModal,
}: Props) => {
  const navigate = useNavigate();
  const isImage = uploadType === CreateUploadDtoTypeEnum.Image;

  const onClick = () => {
    switch (uploadType) {
      case CreateUploadDtoTypeEnum.Video:
        navigate(`/uploads/${uploadId}/mandatory-video-metadata`);
        break;
      case CreateUploadDtoTypeEnum.Document:
        navigate(`/uploads/${uploadId}/mandatory-document-metadata`);
        break;
      default: {
        navigate(`/uploads/${uploadId}/mandatory-metadata`);
      }
    }
  };

  return (
    <ListView id="unique-id" showDivider size="medium" className="mt-space150">
      <ListViewItem
        className="mb-space100 h-space550 w-2/3"
        showDivider
        inset
        emphasised
        onClick={onClick}
        control="navigational"
        controlIcon="arrowRight"
        title="View upload request"
      />
      {isApproved && (
        <ListViewItem
          className="mb-space100 h-space550 w-2/3"
          control="link"
          controlIcon="arrowRight"
          inset
          emphasised
          title="View auto-generated new asset names"
          onClick={onOpenCommentModal}
        />
      )}
      {isImage && isApproved && (
        <ListViewItem
          className="mb-space100 h-space550 w-2/3"
          control="link"
          controlIcon="arrowRight"
          inset
          emphasised
          title="Request images shoppable or cropped"
          href={SUPPORT_TICKET_SHOPPABLE_REQUEST_URL}
          newWindow="_blank"
        />
      )}
    </ListView>
  );
};
